module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.8118/img/storefront-header-blobs.svg"